import PropTypes from 'prop-types';

const formatError = (error) => {
    if (!error || typeof error !== 'string') return error;

    return error.charAt(0).toUpperCase() + error.slice(1).toLowerCase();
};


const ValidationMessage = ({ error }) => {
    return error ? (
        <div className="font-normal validation-text">
            {formatError(error)}
        </div>
    ) : null;
};
ValidationMessage.propTypes = {
    error: PropTypes.string,
};
export default ValidationMessage;
